import React, {Component} from 'react';

import Title from './Title';
import Body from './Body';
import Container from './Container';
import {inject} from "mobx-react";
import {navigate, url} from "js/services/Network";
import AppContent from "js/components/AppContent";
import RatingSmiley2 from "js/components/pages/StatusPage/ItemStatusPage/TransactionReview/RatingSmiley2";
import Constraint from "js/components/Constraint";
import {formatCurrency} from "js/services/Format";

@inject('page')
export default class TransactionReview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      confirmDelivery: false,
      submitting: false,
      modalLaunchReview: false,
      success: false,
    }
  }

  confirmAndPay = () => {
    console.log("launching fund release process...")
    this.setState({paying:!this.state.paying})
    this.props.page.completeOrder();
    if (this.props.page.error === ''){
      //open review modal
      this.openTransactionReviewModal()
    }
  }

  submitReview = () => {

    setTimeout(() => {
      console.log("submitting ...");
      this.setState({submitting:!this.state.submitting})
    }, 2000);
    this.setState({modalLaunchReview:false})
    this.setState({success: true})
  }

  closeReview = () => {
    this.setState({modalLaunchReview:false})
  }

  handleConfirmDelivery = () => {
    this.setState({confirmDelivery: !this.state.confirmDelivery});
  }

  toggle() {
    const { modalLaunchReview } = this.state;
    this.setState({
      modalLaunchReview: !modalLaunchReview
    });
  }

  openTransactionReviewModal = () => {
    this.setState({modalLaunchReview: true})
  }

  render() {
    const page = this.props.page;
    const { modalLaunchReview } = this.state;
    return (
      <>
        {this.state.success ? (
          <AppContent className="seller-link-page" padded>
            <div className="pod-container">
              <div className="tw-flex tw-justify-center tw-pt-4 tw-px-6">
                <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-max-w-xl tw-gap-6">
                  <h5 className="tw-text-center tw-font-semibold tw-text-2xl tw-text-primary">
                    Success!
                  </h5>
                  <img
                    src="/images/icons/love-100.png"
                    alt="success-img"
                    className="tw-w-[100px] tw-h-[100px]"
                  />
                  <p className="tw-text-center tw-text-[#2C353CB2]">

                    Thank you for using POD. Enjoy your item(s).
                  </p>
                  <p className="tw-text-center tw-text-[#2C353CB2]">
                    Awesome right? Now, share some POD love with your friends and we’ll add <span style={{fontWeight: 500}}>{formatCurrency(page.country === 'NG'?3000:25)}</span> to your account to use for your next transactions.
                  </p>
                  {/*<p className="tw-text-center tw-text-[#2C353CB2]">*/}
                  {/*  Awesome right? Now, share some POD love with your friends and we’ll add <span style={{fontWeight:500}}>{formatCurrency(page.country === 'NG'?3000:25)}</span> to your account to use for your next transactions.*/}
                  {/*</p>*/}
                  {/*<button className="tw-mt-2 tw-w-full tw-h-[45px] tw-bg-secondary tw-rounded-lg tw-border tw-border-white tw-text-white"*/}
                  {/*        onClick={() => navigate(url(`/seller/${page.seller}`))}>*/}
                  {/*  <img*/}
                  {/*    src="/images/icons/grid.svg"*/}
                  {/*    alt="shop"*/}
                  {/*    className="size-24px"*/}
                  {/*  />&nbsp;&nbsp;*/}
                  {/*  Continue shopping*/}
                  {/*</button>*/}
                  <button className="tw-mt-2 tw-w-full tw-h-[45px] tw-bg-secondary tw-rounded-lg tw-border tw-border-white tw-text-white"

                          onClick={() => navigate(url('/dashboard/referrals','',''))}>

                    Share the POD&nbsp;&nbsp;
                    <img
                      src="/images/icons/love-51.png"
                      alt="love"
                      className="size-24px"
                    />
                  </button>
                  <button
                    className="tw-w-full tw-h-[45px] tw-bg-white tw-rounded-lg tw-border tw-border-white tw-text-secondary"
                    onClick={() => navigate(url(`/`))}>
                    Go to dashboard
                  </button>
                </div>
              </div>
            </div>
          </AppContent>
        ):(
          <Container>
            <Title style={{float: 'left'}}>Review order</Title><br/>
            <Body>
              <p style={{fontSize: '15px'}}>
                How do you feel about your order? How satisfied are you with this seller and the items you purchased?
              </p>


              {/*<RatingSmiley />*/}
              <AppContent padded>
                <Constraint>
                  <RatingSmiley2 />
                  <button
                    className="tw-w-full tw-h-[45px] tw-bg-secondary tw-rounded-lg tw-border tw-border-white tw-text-white"
                    disabled={this.state.submitting} onClick={this.submitReview} id="sendRatingButton">
                    {this.state.submitting ? 'Submitting ...':'Submit review'}
                  </button>
                </Constraint>
              </AppContent>

            </Body>

          </Container>
        )}
      </>
    )

  }

}

